import React from "react";
import { CONTACT_PREFS, formatPhoneInput } from "../../lib/phone";
import {
  colors,
  fieldStyle,
  hintStyle,
  inputStyle,
  labelRowStyle,
  labelStyle,
} from "./authStyles";

// Mobile number + "reach me by" picker, shared by sign-up and the
// finish-profile step for Google users.
export const PhoneField = ({ value, onChange }) => (
  <div style={fieldStyle}>
    <div style={labelRowStyle}>
      <label htmlFor="phone" style={labelStyle}>
        Mobile number
      </label>
      <span style={hintStyle}>For order updates</span>
    </div>
    <div
      className="auth-input"
      style={{
        ...inputStyle,
        display: "flex",
        alignItems: "center",
        gap: "0.65rem",
        padding: "0 1rem",
      }}
    >
      <span style={{ color: colors.muted }}>+1</span>
      <span
        style={{ width: "1px", height: "20px", backgroundColor: colors.border }}
      />
      <input
        id="phone"
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        placeholder="(647) 555-0147"
        required
        value={value}
        onChange={(e) => onChange(formatPhoneInput(e.target.value))}
        style={{
          flex: 1,
          minWidth: 0,
          height: "100%",
          border: "none",
          outline: "none",
          fontSize: "1rem",
          fontFamily: "inherit",
          background: "transparent",
        }}
      />
    </div>
  </div>
);

export const ContactPrefField = ({ value, onChange }) => (
  <div style={fieldStyle} role="radiogroup" aria-labelledby="contact-pref-label">
    <span id="contact-pref-label" style={labelStyle}>
      When your ball arrives, reach me by
    </span>
    <div style={{ display: "flex", gap: "0.5rem" }}>
      {CONTACT_PREFS.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.4rem",
              height: "44px",
              fontSize: "0.875rem",
              fontWeight: 600,
              fontFamily: "inherit",
              borderRadius: "999px",
              cursor: "pointer",
              border: selected ? "none" : `1px solid ${colors.border}`,
              backgroundColor: selected ? colors.black : "white",
              color: selected ? "white" : colors.black,
            }}
          >
            {selected && (
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke={colors.cyan}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12.5l4.5 4.5L19 7.5" />
              </svg>
            )}
            {option.label}
          </button>
        );
      })}
    </div>
  </div>
);
